module.exports = {
    expressLandingPage: {
        backgroundImagePath: 'https://uatcdn0.woolworths.media/content/express/background-address-validation_large.jpg',
        expressAvailabilityMessage:
            'Woolworths is trading delivery now until',
        expressNonAvailabilityMessage:
            'Sorry delivery now is unavailable in your area',
        expressWindowClosedMessage:
            'Sorry delivery now is unavailable at this time',
        expressValueProposition:
            'Delivered in <span class="expressAddressPanel-titleMessageEstimatedTime">an hour</span>, hand picked with care',
        etaValueProposition:
            'Delivered in a hurry, hand picked with care',
        expressSuccessfullySelectedMessage:
            'Delivery Now has been successfully activated as your current delivery method.',
        expressETASuccessfullySelectedSubMessage:
            'Delivered in a hurry, hand picked with care. You can now start express shopping.',
        expressSuccessfullySelectedSubMessage:
            'Delivered in an hour, hand picked with care. You can now start express shopping.',
        expressImagesPath: 'https://uatcdn0.woolworths.media/content/express/',
        expressETAEnabled: true,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/express-landing-page.js